import React, { ReactElement } from "react";
import { ProductMentionProps as Props } from "./ProductMention.types";
import { Product } from "src/products/types";

import "./ProductMention.scss";

function ProductMention({
    children,
    contentState,
    entityKey,
}: Props): ReactElement {
    const product = contentState
        .getEntity(entityKey)
        ?.getData()
        ?.product as Product | undefined;

    return (
        <span className="ProductMention" title={product?.name}>
            {children}
        </span>
    );
}

export default ProductMention;
